import { generateUUID } from './uuid';

const STORAGE_KEY = 'af_visitor_id';
const STORAGE_TS_KEY = 'af_visitor_id_ts';
const COOKIE_NAME = '_af_vid';
const TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 dias
const TTL_SECONDS = 30 * 24 * 60 * 60; // 30 dias em segundos

function setCookie(value: string): void {
  try {
    document.cookie = `${COOKIE_NAME}=${value}; max-age=${TTL_SECONDS}; path=/; SameSite=Lax; Secure`;
  } catch {
    // Cookie bloqueado
  }
}

function getCookie(): string | null {
  try {
    const match = document.cookie.match(new RegExp(`(?:^|; )${COOKIE_NAME}=([^;]+)`));
    return match ? match[1] : null;
  } catch {
    return null;
  }
}

export function getOrCreateVisitorId(): string | null {
  try {
    const now = Date.now();

    // 1. Tentar localStorage (source of truth)
    const storedId = localStorage.getItem(STORAGE_KEY);
    const storedTs = parseInt(localStorage.getItem(STORAGE_TS_KEY) || '0', 10);

    if (storedId && (now - storedTs) < TTL_MS) {
      // Sliding TTL: renovar timestamp e cookie
      localStorage.setItem(STORAGE_TS_KEY, String(now));
      setCookie(storedId);
      return storedId;
    }

    // 2. Fallback: tentar cookie (backup)
    const cookieId = getCookie();
    if (cookieId) {
      localStorage.setItem(STORAGE_KEY, cookieId);
      localStorage.setItem(STORAGE_TS_KEY, String(now));
      setCookie(cookieId);
      return cookieId;
    }

    // 3. Gerar novo
    const newId = generateUUID();
    localStorage.setItem(STORAGE_KEY, newId);
    localStorage.setItem(STORAGE_TS_KEY, String(now));
    setCookie(newId);
    return newId;
  } catch {
    // Storage bloqueado (modo anônimo, cookies off)
    return null;
  }
}
